<template>
  <CTabs variant="tabs" class="nav-tabs-boxed" :active-tab="abaAtiva" @update:activeTab="abaAtiva = $event">
    <CTab title="Extrato">
      <ExtratoAba @ver-auditoria="abrirAuditoria" />
    </CTab>
    <CTab title="Movimentações">
      <MovimentacoesAba @ver-auditoria="abrirAuditoria" />
    </CTab>
    <CTab title="Auditoria">
      <MovimentosAba :preset-busca="presetAuditoria" :preset-seq="presetSeq" />
    </CTab>
  </CTabs>
</template>

<script>
import ExtratoAba from "./ExtratoAba.vue";
import MovimentacoesAba from "./MovimentacoesAba.vue";
import MovimentosAba from "./MovimentosAba.vue";

export default {
  name: "creditos-clientes",
  components: { ExtratoAba, MovimentacoesAba, MovimentosAba },

  data() {
    return {
      abaAtiva: 0,
      presetAuditoria: "",
      presetSeq: 0,
    };
  },

  methods: {
    // Navegação cruzada: um crédito do Extrato ou uma operação da listagem
    // abre a Auditoria já filtrada pela chave correspondente.
    abrirAuditoria(busca) {
      this.presetAuditoria = String(busca);
      // O contador força a reaplicação mesmo quando a busca é a mesma da vez
      // anterior (o watcher de valor igual não dispara).
      this.presetSeq += 1;
      this.abaAtiva = 2;
    },
  },
};
</script>

<!-- Visual do módulo segue o design system do Tintométrico (mesmo CSS). -->
<style src="../Tintometrico/tintometrico.css"></style>
